<template>
  <div style="overflow: hidden">
    <div class="wrapper_all wrapper_app_job flex-col">
      <div class="header">
        <el-button @click="goBack">返回</el-button>
      </div>
      <div class="body-right">
        <div class="body-right-header">
          <div class="body-right-header-left">
            <el-tag
              v-if="
                problems &&
                problems[0] &&
                problems[0].original &&
                problems[0].original
              "
              type="danger"
              style="margin-top: 10px"
              >原创题</el-tag
            >
            <el-divider
              direction="vertical"
              v-if="
                problems &&
                problems[0] &&
                problems[0].original &&
                problems[0].original
              "
            ></el-divider>
            <span class="tagItem">{{
              topicDetail && topicDetail.species
                ? topicDetail.species
                : "无题型分类"
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="tagItem">{{
              topicDetail &&
              (topicDetail.problemType || topicDetail.problemType == 0)
                ? speciesTypeList[topicDetail.problemType]
                : "无类型分类"
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="tagItem">{{
              topicDetail && (topicDetail.level || topicDetail.level == 0)
                ? "难度：" + levelList[topicDetail.level-1]
                : "无难度等级"
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="tagItem">{{
              topicDetail && topicDetail.baseTime
                ? "基准时间：" + topicDetail.baseTime + "秒"
                : "无基准时间"
            }}</span>
          </div>
        </div>

        <div class="body-right-body">
          <div v-for="item in problems" :key="item.id">
            <div>
              <el-tag>题干</el-tag>
            </div>
            <div v-html="item.caption"></div>
            <div v-html="item.question"></div>
            <div v-if="item.option">
              <div
                v-for="(item2, key) in item.option"
                :key="key"
                class="optionItem"
              >
                <div>{{ key }}</div>
                ：
                <div>{{ item2 }}</div>
              </div>
            </div>
            <div>
              <el-tag>答案</el-tag>
            </div>
            <div v-if="Array.isArray(item.answer)" style="display: flex">
              <div
                v-for="item2 in item.answer"
                :key="item2"
                v-html="item2"
                style="margin-right: 10px"
              ></div>
            </div>

            <div>
              <el-tag>解析</el-tag>
            </div>
            <div v-html="item.analyze"></div>
          </div>
        </div>
        <!-- 后面改 -->
        <div class="body-right-footer">
          <span class="footerItem"
            >最后更新：{{
              problems[0] &&
              problems[0].updateTime &&
              problems[0].updateTime.split(" ")[0]
            }}</span
          >
          <el-divider direction="vertical"></el-divider>
          <span class="footerItem"
            >操作人：{{ problems[0] && problems[0].creator }}</span
          >
          <el-divider direction="vertical"></el-divider>
          <span class="footerItem">出题：{{ $route.query.useTimes }} 次</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      levelList: ["一星", "二星", "三星", "四星", "五星"],
      speciesTypeList: ["常规题", "基础进阶", "水平进阶"],
      loading: false,
      id: "",
      useTimes: "",
      problems: [],
      topicDetail: {},
    };
  },
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getDetail() {
      let url = `/bank/problem/v1.0/problems/${this.id}`;
      this.axios.get(url).then((res) => {
        if (res.data.code == 200) {
          const topicDetail = { ...res.data.data };
          this.problems = topicDetail.problems;
          this.topicDetail = topicDetail;
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            duration: 1300,
          });
        }
      });
    },
  },

  mounted() {
    this.id = this.$route.query.id;
    this.useTimes = this.$route.query.useTimes;
    this.getDetail();
  },
  beforeDestroy() {},
};
</script>

<style  scope>
.wrapper_all {
  background: #ffffff;
  font-size: 16px;
  height: calc(100vh - 232px);
  overflow-y: auto;
  margin-bottom: 0px;
}
.header {
  padding: 16px;
  text-align: right;
}
.body-right {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 16px;
}
.body-right-header {
  box-sizing: border-box;
  padding: 0 16px;
  height: 68px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tagItem {
  margin: 0 6px;
  color: #808080;
  font-size: 16px;
  margin-bottom: 4px;
}

.body-right-header-left {
  display: flex;
  align-items: center;
}
.body-right-header-right {
  display: flex;
}
.body-right-header-item {
  position: relative;
  margin-bottom: 12px;
  display: flex;
}
.body-right-header-item-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.body-right-header-item-title {
  padding-left: 4px;
  margin-bottom: 2px;
  display: block;
  margin-right: 4px;
  padding-top: 2px;
  width: 46px;
  flex-grow: 0;
  flex-shrink: 0;
}
.body-right-header-item-text {
  position: relative;
  color: #808080;
  margin-right: 8px;
  padding: 2px 6px;
  margin-bottom: 4px;
  font-size: 16px;
  cursor: pointer;
}
.isActive {
  background-color: #409eff;
  color: #fff;
  border-radius: 2px;
}
.collapse {
  position: absolute;
  right: 0;
  top: -6px;
  font-size: 16px;
}

.sortItemIcon {
  color: #fff;
  position: absolute;
  right: -2px;
  top: 6px;
}
.el-icon-more {
  cursor: pointer;
  color: #808080;
  margin-left: 12px;
}
.body-right-footer {
  display: flex;
  box-sizing: border-box;
  height: 40px;
  border-top: 1px solid #d7d9da;
  align-items: center;
  padding-left: 16px;
}
.pagenation-left {
  font-size: 13px;
  min-width: 35.5px;
  margin-right: 10px;
  font-weight: 400;
  color: #606266;
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  letter-spacing: 0.5px;
}
.footerItem {
  color: #808080;
  font-size: 16px;
  margin: 0 8px;
}
.treeNode {
  font-size: 15px;
}

.optionItem {
  display: flex;
}
</style>
